import {createContext, type ReactNode, type RefObject, use} from 'react'

export interface ContentPreviewComponentProps {
  returnFocusRef: RefObject<HTMLElement | null>
  disableResourcePanel?: boolean
  disableActionsMenu?: boolean
  hideExpandButton?: boolean
  className?: string
}

type ContentPreviewRenderer = (props: ContentPreviewComponentProps) => ReactNode

/**
 * Provides a render function for ContentPreview via context to avoid circular module dependencies.
 * Consumers (e.g. TaskChat in agent-sessions) use ContentPreviewSlot instead of
 * importing ContentPreview directly.
 */
export const ContentPreviewRendererContext = createContext<ContentPreviewRenderer | null>(null)

/**
 * Stable wrapper component that renders ContentPreview from context.
 * Uses a render function pattern to avoid React Compiler's
 * "Cannot create components during render" error.
 */
export function ContentPreviewSlot({
  returnFocusRef,
  disableResourcePanel,
  disableActionsMenu,
  hideExpandButton,
  className,
}: ContentPreviewComponentProps) {
  const renderer = use(ContentPreviewRendererContext)
  if (!renderer) return null
  return renderer({returnFocusRef, disableResourcePanel, disableActionsMenu, hideExpandButton, className})
}
